import store from '../store/store';

export default ({ next, to, router }) => {
  const permissions = store.getters['auth/user'] ? store.getters['auth/user'].permissions : null;
  if (permissions === null || !to.meta.permission) {
    return next();
  }
  if (!permissions.includes(to.meta.permission)) {
    router.push({ name: to.meta.fallback });
  } else {
    next();
  }
};
